// extracted by mini-css-extract-plugin
module.exports = {"root":"Pagination_root__tOwkK","pages":"Pagination_pages__2nltI"};